/**
 * Per-pair swap/commission totals over the currently open book.
 *
 * The live feed's per-pair profit is already NET — the indicator sums
 * OrderProfit() + OrderSwap() + OrderCommission() per symbol — but it sends
 * only that single number. The breakdown comes from the synced open-order
 * rows instead, whose swap/commission are refreshed on every sync cycle.
 *
 * Honesty flags matter here: rows synced before the indicator sent cost
 * fields carry NULLs ("never captured"), and the event log can miss orders
 * entirely, so a breakdown may cover fewer orders than are actually open.
 */
import { normalizeBasketSymbol } from './basketMonitor';
/** Keyed by normalized symbol. Only symbols with at least one synced row appear. */
export const computePairOpenCosts = (positions) => {
    const costs = new Map();
    for (const position of positions) {
        const symbol = normalizeBasketSymbol(position.pair);
        let entry = costs.get(symbol);
        if (!entry) {
            entry = { symbol, swapUsd: 0, commissionUsd: 0, syncedOrders: 0, costsIncomplete: false };
            costs.set(symbol, entry);
        }
        entry.syncedOrders += 1;
        entry.swapUsd += position.swap ?? 0;
        entry.commissionUsd += position.commission ?? 0;
        if (position.swap == null || position.commission == null) {
            entry.costsIncomplete = true;
        }
    }
    return costs;
};
